<!--金刚位-图文详情 -->
<template>
    <div class="image-text">
        <div class="image-text-content" v-html="result && result.content"></div>
    </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
    name: "index",
    data() {
        return {
            id: '',
            result: null
        }
    },
    created() {
        this.id = this.$route.params.id
        this.init()
    },
    methods: {
        init() {
            Interface.getData('get', Interface.v4.text_desc + '/' + this.id).then((res) => {
                if (res.code == 0) {
                    this.result = res.data
                    document.title = res.data.title

                    let desc = "点击查看更多"
                    if(this.id == 33){
                        desc = "更快更准确的找到你需要的那一篇"
                    }
                    Interface.getShareInfo(this,res.data.title,"",desc)
                }
            })
        }
    }
}
</script>

<style lang="scss">
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/image-text/index.vue